export enum DownloadDocumentType {
  PDF = 'pdf',
  DOCX = 'docx',
  IMAGE = 'image',
  XLSX = 'xlsx',
  CSV = 'csv',
}
